import styled from '@emotion/styled';

const Name = styled('h4')(({ theme }) => ({
  color: theme.palette.text.primary,
  whiteSpace: 'nowrap',
  fontWeight: 400,
}));

export default Name;
